/**
 * Core main: фильтры каталога, пагинация, счётчики qty, Person title, cookie-модалка,
 * EditorJS read-only рендер, wishlist toggle.
 *
 * Все AJAX → apiRequest. Обработчики делегированы через document.addEventListener.
 */

import { apiRequest } from '../api.js';

const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
const locale = document.querySelector('meta[name="locale"]')?.getAttribute('content');

function validateEmail(email) {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        );
}

// URL helpers
function getUrlParameter(name) {
    const pageURL = window.location.search.substring(1);
    const vars = pageURL.split('&');
    for (let i = 0; i < vars.length; i++) {
        const parts = vars[i].split('=');
        if (parts[0] === name) {
            return parts[1] === undefined ? true : decodeURIComponent(parts[1]);
        }
    }
    return false;
}

function setGetParam(key, value, reload = false) {
    if (!history.pushState) return;
    const params = new URLSearchParams(window.location.search);
    params.set(key, value);
    const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${params.toString()}`;
    window.history.pushState({ path: newUrl }, '', newUrl);
    if (reload) location.reload();
}

function isMobile() {
    if ('maxTouchPoints' in navigator) return navigator.maxTouchPoints > 0;
    const mQ = matchMedia?.('(pointer:coarse)');
    if (mQ?.media === '(pointer:coarse)') return !!mQ.matches;
    if ('orientation' in window) return true;
    return /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(navigator.userAgent)
        || /\b(Android|Windows Phone|iPad|iPod)\b/i.test(navigator.userAgent);
}

// Page state
let page = getUrlParameter('page') || 1;
function setPage(value) { page = value; }

// Search/filter state
let search_values = {
    subcategory: getUrlParameter('subcategory_filter') ? JSON.parse(getUrlParameter('subcategory_filter')) : [],
    material: getUrlParameter('material_filter') ? JSON.parse(getUrlParameter('material_filter')) : [],
    style: getUrlParameter('style_filter') ? JSON.parse(getUrlParameter('style_filter')) : [],
    brand: getUrlParameter('brand_filter') ? JSON.parse(getUrlParameter('brand_filter')) : [],
    category: getUrlParameter('category_filter') ? JSON.parse(getUrlParameter('category_filter')) : [],
    search: getUrlParameter('search') ? [getUrlParameter('search')] : [],
    view_more: [],
    manufacturer: [],
    status: [],
    tags: getUrlParameter('tags_filter') ? JSON.parse(getUrlParameter('tags_filter')) : [],
    cat_id: getUrlParameter('cat_id') ? getUrlParameter('cat_id') : 0,
};

function setSearchValue(key, value) { search_values[key].push(value); }
function removeSearchValue(key, value) {
    const index = search_values[key].indexOf(value);
    if (index !== -1) search_values[key].splice(index, 1);
}
function resetSearchValue(key) { search_values[key] = []; }
function getSearchValues() { return search_values; }

async function getProducts() {
    const brandIdInput = document.querySelector('input[name=brand_id]');
    const brand_id = brandIdInput?.value || 0;
    const is_wishlist = document.querySelector('input[name=is_wishlist]') ? 1 : 0;

    try {
        const response = await apiRequest(
            `/project/get/products?page=${page}&brand_id=${brand_id}&is_mobile=${is_wishlist}&is_wishlist=${is_wishlist}`,
            { method: 'POST', body: search_values },
        );
        const list = document.querySelector('.js_products-list');
        if (!list) return;

        // DEV-328: пагинация — список всегда перерисовывается полностью
        list.innerHTML = response.html_products;

        const paginationContainer = document.getElementById('catalog_pagination_container');
        if (paginationContainer && typeof response.html_pagination === 'string') {
            paginationContainer.innerHTML = response.html_pagination;
        }

        const qtyPagesInput = document.querySelector('input[name=qty_pages]');
        if (qtyPagesInput && response.qty_pages) {
            qtyPagesInput.value = response.qty_pages;
        }
    } catch (e) {
        console.error('getProducts failed:', e);
    }
}

async function getProjects(type = 2) {
    try {
        const response = await apiRequest(`/get/projects?page=${page}`, {
            method: 'POST',
            body: { type },
        });

        const qtyPages = Number(document.querySelector('input[name=qty_page]')?.value || 0);
        if (page >= qtyPages) {
            const btn = document.getElementById('section_pagination_button');
            if (btn) btn.style.display = 'none';
        }
        const list = document.querySelector('.js_projects-list');
        if (list) list.insertAdjacentHTML('beforeend', response.html_projects);
    } catch (e) {
        console.error('getProjects failed:', e);
    }
}

async function setCookie(cookie_settings) {
    try {
        await apiRequest('/set/cookie', { method: 'POST', body: { cookie_settings } });
    } catch (e) {
        console.error('setCookie failed:', e);
    }
}

function init() {
    // Первичная инициализация фильтра из скрытых полей
    const brandIdInput = document.querySelector('input[name=brand_id]');
    if (brandIdInput) setSearchValue('brand', Number(brandIdInput.value));

    const categoryIdInput = document.querySelector('input[name=category_id]');
    if (categoryIdInput) setSearchValue('category', Number(categoryIdInput.value));

    const searchStringInput = document.querySelector('input[name=search_string]');
    if (searchStringInput) setSearchValue('search', searchStringInput.value);

    if (
        search_values.brand.length > 0
        || search_values.subcategory.length > 0
        || search_values.style.length > 0
        || search_values.material.length > 0
        || search_values.category.length > 0
        || search_values.tags.length > 0
    ) {
        getProducts();
    }

    // Фильтры: клик по чекбоксам фильтра
    document.addEventListener('click', e => {
        const cb = e.target.closest('input[type=checkbox]');
        if (!cb) return;

        const type = cb.dataset.type;
        const val = cb.dataset.id;
        if (!type || !val) return;

        if (cb.checked) setSearchValue(type, val);
        else removeSearchValue(type, val);

        if (type === 'subcategory' || type === 'category') {
            if (!document.querySelector('input[name=brand_id]')) resetSearchValue('brand');
            if (type === 'subcategory') {
                const catId = Number(cb.dataset.cat);
                setGetParam('cat_id', catId);
                search_values.cat_id = catId;
            }
            resetSearchValue('material');
            resetSearchValue('style');
            resetSearchValue('tags');
            document.querySelectorAll(
                '.js_filter-brands input, .js_filter-materials input, .js_filter-styles input, .js_filter-tags input',
            ).forEach(input => { input.checked = false; });
        }
        if (type === 'category') {
            resetSearchValue('subcategory');
            document.querySelectorAll('.js_filter-subcategories input').forEach(i => { i.checked = false; });
        }

        const values = getSearchValues();
        setGetParam(`${type}_filter`, JSON.stringify(values[type]));
        setPage(1);
        setGetParam('page', 1);
        getProducts();
    });

    // Пагинация (legacy Show More — projects/news всё ещё используют)
    document.addEventListener('click', e => {
        const btn = e.target.closest('#section_pagination_button');
        if (!btn) return;
        setPage(Number(page) + 1);
        const type = btn.dataset.type;
        if (type === 'projects' || type === 'news') {
            getProjects(type === 'news' ? 1 : 2);
        } else {
            getProducts();
        }
    });

    // DEV-328: каталог — постраничная навигация
    document.addEventListener('click', e => {
        const link = e.target.closest('.catalog-pagination-link[data-page]');
        if (!link || link.disabled) return;
        const target = Number(link.dataset.page);
        if (!target || target === Number(page)) return;

        setPage(target);
        setGetParam('page', target);
        getProducts();

        const container = document.getElementById('section_pagination_container')
            || document.querySelector('.js_products-list');
        if (container) container.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    // Цена товара на выборе размера
    document.addEventListener('change', e => {
        const select = e.target.closest('.js_select-price');
        if (!select) return;

        const opt = select.options[select.selectedIndex];
        const price = Number(opt?.dataset.price || 0);
        const priceLabel = document.querySelector('.js_product-price');
        const priceValue = document.getElementById('js_product_price');

        if (price > 0) {
            if (priceLabel) priceLabel.style.display = '';
            if (priceValue) priceValue.textContent = price;
        } else if (priceLabel) {
            priceLabel.style.display = 'none';
        }
    });

    // Quantity widgets (+ / -)
    document.addEventListener('click', e => {
        const minus = e.target.closest('.js_btn-minus');
        const plus = e.target.closest('.js_btn-plus');
        const btn = minus || plus;
        if (!btn) return;

        e.preventDefault();
        e.stopPropagation();

        const parent = btn.parentElement;
        const input = parent?.querySelector('input[name="quantity"]');
        const qtyDisplay = parent?.querySelector('.js_product-qty');
        if (!input) return;

        let val = parseInt(input.value, 10) || 1;
        if (minus && val > 1) val--;
        else if (plus && val < 99) val++;
        else return;

        input.value = val;
        if (qtyDisplay) qtyDisplay.textContent = val;

        const priceInput = document.querySelector('input[name=base_price]');
        const basePrice = Number(priceInput?.value || 0);
        if (basePrice) {
            const total = (val * basePrice).toFixed(2);
            const totalEl = document.querySelector('.counted-price');
            if (totalEl) totalEl.textContent = total;
        }
    });

    // Person title (Mr./Mrs./Ms.)
    const titles = ['Mr.', 'Mrs.', 'Ms.'];
    document.addEventListener('click', e => {
        const trigger = e.target.closest('.js_title_next');
        if (!trigger) return;

        const type = trigger.dataset.type;
        const input = document.querySelector('input[name=person_title]');
        const display = document.querySelector('.js_title-value');
        if (!input) return;

        const currentTitle = input.value;
        let currentIndex = titles.indexOf(currentTitle);
        if (currentIndex === -1) currentIndex = 0;

        if (type === 'plus') {
            currentIndex = titles[currentIndex + 1] ? currentIndex + 1 : 0;
        } else {
            currentIndex = titles[currentIndex - 1] ? currentIndex - 1 : titles.length - 1;
        }

        input.value = titles[currentIndex];
        if (display) display.textContent = titles[currentIndex];
    });

    // Cookie modal overlay
    let cookie_settings = JSON.parse(localStorage.getItem('cookie_settings'));
    if (!cookie_settings) {
        document.getElementById('cookieOverlay')?.classList.add('is-active');
    }

    document.addEventListener('click', e => {
        const accept = e.target.closest('.js_accept-cookie');
        if (accept) {
            const level = Number(accept.dataset.level);
            if (level !== 2) {
                cookie_settings = { level };
                localStorage.setItem('cookie_settings', JSON.stringify(cookie_settings));
                setCookie(cookie_settings);
            }
            return;
        }

        const setOptionsBtn = e.target.closest('.js_set-cookie-options-btn');
        if (setOptionsBtn) {
            const cookie_options = [];
            document.querySelectorAll('.js_cookie-option').forEach(cb => {
                if (cb.checked) cookie_options.push(Number(cb.dataset.cookieOption));
            });
            cookie_settings = { level: 2, cookie_options };
            localStorage.setItem('cookie_settings', JSON.stringify(cookie_settings));
            setCookie(cookie_settings);
        }
    });

    // EditorJS read-only рендер, если есть контейнер
    const editorEl = document.getElementById('editorjs');
    if (editorEl && typeof EditorJS !== 'undefined') {
        let content = document.querySelector('input[name=content]')?.value;
        content = content ? JSON.parse(content) : {};

        // eslint-disable-next-line no-new
        new EditorJS({
            autofocus: true,
            holder: 'editorjs',
            readOnly: true,
            tools: {
                header: { class: Header, inlineToolbar: ['link'] },
                image: { class: SimpleImage, inlineToolbar: true },
                list: { class: List, inlineToolbar: true },
                linkTool: { class: LinkTool, inlineToolbar: true },
                delimiter: Delimiter,
                paragraph: { class: Paragraph, inlineToolbar: true },
            },
            data: content,
        });
    }

    // Wishlist toggle
    document.addEventListener('click', async e => {
        const btn = e.target.closest('.js_add-to-wishlist');
        if (!btn) return;
        e.preventDefault();

        const id = btn.dataset.id;
        try {
            const ans = await apiRequest('/add/to/wishlist', {
                method: 'POST',
                body: { id },
            });
            if (ans === 'added') btn.classList.add('active');
            else if (ans === 'deleted') btn.classList.remove('active');
        } catch (err) {
            console.error('wishlist toggle error:', err);
        }
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}

// Публичные утилиты
window.getUrlParameter = getUrlParameter;
window.setGetParam = setGetParam;
window.isMobile = isMobile;
window.validateEmail = validateEmail;
